import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { prepareParcels } from '../model';
import parcelDetailsColumns from '../../../components/RouteManagement/ParcelDetails/parcelDetailsColumns';
import {
  getSelectedParcels,
  getSelectedPreparedStops,
} from '../../../store/selectors/ui/routeDetail';
import { stopParcelDetailsColumnsConfigs } from '../../../enums/columnsConfigs';

export default ({
  headerCellClasses,
  bodyCellClasses,
  isKingParcelColumnDisabled,
  modifiers,
}) => {
  const selectedParcels = useSelector(getSelectedParcels);
  const [stop] = useSelector(getSelectedPreparedStops);

  return useMemo(
    () => ({
      columns: parcelDetailsColumns({
        modifiers,
        columnsConfigs: stopParcelDetailsColumnsConfigs,
        headerCellClasses,
        bodyCellClasses,
        isKingParcelColumnDisabled,
      }),
      data: prepareParcels(stop, selectedParcels),
    }),
    [
      modifiers,
      headerCellClasses,
      bodyCellClasses,
      stop,
      selectedParcels,
      isKingParcelColumnDisabled,
    ]
  );
};
